import { Index, Show, createMemo, createSignal } from "solid-js";
import Accordion from "../../st-accordion/st-accordion";
import { loadView, openViewInDialog } from "../../st-view/st-view";
import { requireJobQueueStatusContext } from "../JobQueueStatusContext";
import style from '../st-job-queue-status.module.css'
import STButton from "../../st-button/st-button";
import { JobInfoRow } from "./JobInfoRow";
import Button from "../../st-button/st-button";
import STModal from "../../st-modal/st-modal";
import Flexbox from "../../st-flexbox/st-flexbox";

export function JobQueuePanel() {
    const jqContext = requireJobQueueStatusContext();

    const openUserViewer = () => {
        loadView('VIEW', '211CE8CC-8B52-42E4-9C4A-014824D814E1', true)
    }

    const openAdminViewer = () => {
        loadView('VIEW', '82ACAB90-ABA7-48D0-96B5-6522F5AE07DF', true)
    }
    
    const onHistoryScroll = (e: Event) => {
        const container = e.target as HTMLDivElement;

        const distanceToBottom = container.scrollHeight - container.clientHeight - container.scrollTop;

        if (distanceToBottom < 10 && !jqContext.loadingHistoricalJobs()) {
            jqContext.loadMoreJobs();
        }
    }

    const rescheduleOpen = createSignal(false);

    const launchRescheduler = () => {
        const identity = jqContext.selectedJobIds().join(',');
        jqContext.setSelectedJobIds([]);
        openViewInDialog('ED8F3484-B4BC-4F30-B861-60A6D3210A05', identity, { mode: 'ADD'});
    }

    return (
        <div class={style['status-panel']}>
            <Accordion multiple>
                <Accordion.Item
                    title={
                        <>
                            <span class={style['info-row-title']}>Current Jobs  ({jqContext.singularJobs().length})</span>
                            <Show when={jqContext.completedJobs().length > 1}>
                                <Button icon='fa fa-xmark' style={{ position: 'absolute', right: '16px', "font-size": "12px" }} type='warning' onClick={() => jqContext.dismissAll()}>Dismiss All</Button>
                            </Show>
                        </>
                    }
                    open
                >
                    <div style='max-height: 300px; overflow-y: auto;'>
                        <Show when={jqContext.singularJobs().length === 0}>
                            <div class='flexbox middle' style='padding: 8px; font-style: italic;'>
                                No Active Jobs
                            </div>
                        </Show>
                        <Index each={jqContext.singularJobs()}>{j => (
                            <JobInfoRow job={j()} />
                        )}</Index>
                    </div>
                </Accordion.Item>

                <Accordion.Item title={<span class={style['info-row-title']}>Recent</span>}>
                    <div style='max-height: 300px; overflow-y: auto;' onScroll={onHistoryScroll}>
                        <Show when={!jqContext.loadingHistoricalJobs() && jqContext.historicalJobs().length === 0}>
                            <div class='flexbox middle' style='padding: 8px; font-style: italic;'>
                                No Historical Jobs
                            </div>
                        </Show>

                        <Index each={jqContext.historicalJobs()}>{j => (
                            <JobInfoRow job={j()} historical />
                        )}</Index>

                        <Show when={jqContext.loadingHistoricalJobs()}>
                            <div class='flexbox middle' style='padding: 8px; font-style: italic;'>
                                Loading...
                            </div>
                        </Show>
                    </div>
                </Accordion.Item>

                <Accordion.Item title={<span class={style['info-row-title']}>Recurring Jobs ({jqContext.recurringJobs().length})</span>}>
                    <div style='max-height: 300px; overflow-y: auto;'>
                        <Show when={jqContext.recurringJobs().length === 0}>
                            <Flexbox dir="horizontal" middle style='padding: 8px; font-style: italic;'>
                                <Flexbox.Item auto>No Recurring Jobs</Flexbox.Item>
                            </Flexbox>
                        </Show>

                        <Flexbox dir="horizontal" middle style={{ "justify-content": "center", padding: "4px" }}>
                            <Button enabled={jqContext.selectedJobIds().length > 0} onClick={launchRescheduler}>
                                Reschedule
                            </Button>
                        </Flexbox>

                        <Index each={jqContext.recurringJobs()}>{j => (
                            <JobInfoRow job={j()} />
                        )}</Index>
                    </div>
                </Accordion.Item>


            </Accordion>

            <div class={style['status-panel-actions']}>
                <Show when={jqContext.canAccessUserViewer()}>
                    <STButton onClick={openUserViewer}>JobQueue Viewer</STButton>
                </Show>

                <Show when={jqContext.canAccessAdminViewer()}>
                    <STButton onClick={openAdminViewer}>JobQueue Admin</STButton>
                </Show>
            </div>
        </div>
    )
}
